import { defineStore } from "pinia";
import AfterOrderPay from "../../../base/ts/events/Checkout/AfterOrderPay";
import PledgClient from "../PledgClient";

export const useCustomizationCheckoutStore = defineStore("customizationCheckout", () => {
    // Services
    const pledgClient: PledgClient = new PledgClient();

    // Methods
    async function afterOrderPay(afterOrderPayEvent: AfterOrderPay) {
        let responseData = afterOrderPayEvent.responseBody;

        if (responseData?.payment?.method?.provider?.name === "pledg") {
            afterOrderPayEvent.requestPreventDefaultBehaviour = true;

            let redirectUrl = responseData.redirectUrl + "?order_id=" + responseData.payment.order.id;

            pledgClient.init(responseData.orderDetails, redirectUrl);
            pledgClient.open();
        } else if (responseData?.payment?.method?.provider?.name === "SVEA") {
            afterOrderPayEvent.requestPreventDefaultBehaviour = true;
            afterOrderPayEvent.customRedirectUrl =
                window.location.origin + "/checkout/svea?order_id=" + responseData.payment.order.id;
        }
    }

    return { afterOrderPay };
});
